const getTime = (message) => {
	const value = message?.created_at || message?.time || message?.updated_at;
	const date = value ? new Date(value) : null;

	return date && !Number.isNaN(date.getTime()) ? date.getTime() : 0;
};

const getKey = (message) => message?.id ?? `${message?.created_at || ''}-${message?.text || ''}`;

export const mergeMessages = (...lists) => {
	const map = new Map();

	lists.forEach((list) => {
		(Array.isArray(list) ? list : []).forEach((message) => {
			if (!message) return;

			map.set(getKey(message), message);
		});
	});

	return [...map.values()].sort((a, b) => getTime(a) - getTime(b));
};

export const toMessagesList = (data) => {
	const root = data?.chat?.messages || data?.messages || data || {};

	const income = root?.income || [];
	const outcome = root?.outcome || [];
	const system = root?.system || [];

	return [...income, ...outcome, ...system.map((message) => ({ ...message, isSystem: true }))];
};
